import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../auth/auth-context';
import { useOrg } from '../pages/orgs/org-context';
import { useProject } from '../pages/projects/project-context';
import Layout from '../layout/Layout';

export default function ProtectedRoute({
  children,
  requireAuth = true,
  requiredGlobals = [],
  requiredOrgRoles = [],
  requireProject = false,
}) {
  const { user, isLoading } = useAuth();
  const { activeOrgId, memberships, loading: orgLoading } = useOrg();
  const { activeProjectId, loading: projectLoading } = useProject();
  const { orgId: routeOrgId } = useParams();
  const location = useLocation();

  if (isLoading || orgLoading || projectLoading) return null;

  // ---------------------------
  // Auth required
  // ---------------------------
  if (requireAuth && !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ---------------------------
  // Global role check
  // ---------------------------
  if (requiredGlobals.length) {
    const globals = user?.globals || [];
    const ok = requiredGlobals.some(r => globals.includes(r));
    if (!ok) return <Navigate to="/unauthorized" replace />;
  }

  // ---------------------------
  // Org role check
  // ---------------------------
  if (requiredOrgRoles.length) {
    // superadmin bypass
    if (user?.globals?.includes('superadmin')) {
      return <Layout>{children}</Layout>;
    }

    const orgToCheck = routeOrgId || activeOrgId;
    if (!orgToCheck) {
      return <Navigate to="/unauthorized" replace />;
    }

    const membership = memberships?.find(m => {
      const mid =
        m.orgId?._id ||
        m.orgId ||
        m.org ||
        m.organizationId;
      return String(mid) === String(orgToCheck);
    });

    if (!membership) {
      return <Navigate to="/unauthorized" replace />;
    }

    const ok = requiredOrgRoles.some(r =>
      membership.roles?.includes(r)
    );

    if (!ok) {
      return <Navigate to="/unauthorized" replace />;
    }
  }
  if (
    requireProject &&
    !activeProjectId
  ) {
    return (
      <Navigate
        to="/projects"
        replace
      />
    );
  }
  return <Layout>{children}</Layout>;
}
